import React, {useState, useEffect} from 'react';
import './Popular.css';
import axios from 'axios'; 
import Item from '../Item/Item';

const Popular = () => {

    const [dataProduct, setDataProduct] = useState([]);
    
    // let all_product =[];
    const apiURL = process.env.REACT_APP_API_URL;

    var options = {  
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Origin': '',
            Accept: 'application/json', 
            'ngrok-skip-browser-warning': "10423"
        }
    }

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(apiURL + `api/products/get/popular`, options);
                const data = await response.json();
                setDataProduct(data);
            } catch (error) {
                console.error('Failed to fetch common values', error);
            }
        };

        fetchProducts();
    }, []);

    // let data_product = [];
    // const apiURL = process.env.REACT_APP_API_URL;
    // axios.get(apiURL + `api/products/get/popular`, {
    //     headers: {
    //         Accept: 'application/json',
    //         "ngrok-skip-browser-warning": "10423"
    //     }
    // })
    // .then((res) => {
    //     data_product = res.data;
    // })
    // .catch((err) => console.log(err));

    return (
        <div className="popular">
            <h2>Popular in Grocery</h2>
            <hr/>
            <div className="popular-item">
                {dataProduct.map((item, i)=>{
                    return <Item key={i} id={item.id} name={item.name} img={item.img} price={item.price}/>
                })}
            </div>
        </div>
    )
}

export default Popular